import { ListItemElement } from '@components/std-components/SelectComponent'
import React, { ElementType, FC } from 'react'

export interface ChipListProps {
  values: string[]
  itemTemplate: ElementType<ListItemElement>
  onDeselect: (option: string) => void
  disabled?: boolean
}

const ChipList: FC<ChipListProps> = ({
  values,
  itemTemplate: ItemTemplate,
  onDeselect,
  disabled
}) => {
  return (
    <>
      {values.map(value => (
        <ItemTemplate
          isSelected={true}
          onDeselect={() => onDeselect(value)}
          onSelect={() => {}}
          option={value}
          key={value}
          disabled={disabled}
        />
      ))}
    </>
  )
}

export default ChipList
